import React, {PropsWithChildren} from "react";
import {css, Theme} from "@emotion/react";

import {cellWidth, cellWidthMd, cellWidthPrint, cellWidthSm, cellWidthXl} from "../../styles/table_cell_styles";

interface IProps extends PropsWithChildren {
    isDisabled?: boolean;
}

export const CellHeader = (props: IProps) => {
    return <div css={[headerStyle, props.isDisabled && disabledHeaderStyle]}>{props.children}</div>;
};

const headerStyle = (theme: Theme) => css`
    position: relative;
    user-select: none;
    ${cellWidthSm};

    @media (min-width: ${theme.breakpoints.sm}) {
        ${cellWidthMd};
    }

    @media (min-width: ${theme.breakpoints.md}) {
        ${cellWidthXl};
    }

    @media (min-width: ${theme.breakpoints.xl}) {
        ${cellWidth};
    }

    @media print {
        ${cellWidthPrint};
    }
`;

const disabledHeaderStyle = css`
    opacity: 0.8;
`;
import React, {PropsWithChildren} from "react";
import {css, Theme} from "@emotion/react";

import {cellWidth, cellWidthMd, cellWidthPrint, cellWidthSm, cellWidthXl} from "../../styles/table_cell_styles";

interface IProps extends PropsWithChildren {
    isDisabled?: boolean;
}

export const CellHeader = (props: IProps) => {
    return <div css={[headerStyle, props.isDisabled && disabledHeaderStyle]}>{props.children}</div>;
};

const headerStyle = (theme: Theme) => css`
    position: relative;
    user-select: none;
    ${cellWidthSm};

    @media (min-width: ${theme.breakpoints.sm}) {
        ${cellWidthMd};
    }

    @media (min-width: ${theme.breakpoints.md}) {
        ${cellWidthXl};
    }

    @media (min-width: ${theme.breakpoints.xl}) {
        ${cellWidth};
    }

    @media print {
        ${cellWidthPrint};
    }
`;

const disabledHeaderStyle = css`
    opacity: 0.8;
`;
